import { render, staticRenderFns } from "./mathematics.vue?vue&type=template&id=59cfdf90&"
import script from "./mathematics.vue?vue&type=script&lang=js&"
export * from "./mathematics.vue?vue&type=script&lang=js&"
import style0 from "./mathematics.vue?vue&type=style&index=0&id=59cfdf90&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports